import { render } from "./CertificateGeneratorForm.vue?vue&type=template&id=cc83afae"
import script from "./CertificateGeneratorForm.vue?vue&type=script&lang=js"
export * from "./CertificateGeneratorForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__